var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5.375H5.95833C5.36002 5.375 4.875 5.86002 4.875 6.45833V11.3333C4.875 11.9316 5.36002 12.4167 5.95833 12.4167H10.8333C11.4316 12.4167 11.9167 11.9316 11.9167 11.3333V6.45833C11.9167 5.86002 11.4316 5.375 10.8333 5.375Z",
    stroke: "#163663",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70825 8.62492H2.16659C1.87927 8.62492 1.60372 8.51078 1.40055 8.30762C1.19739 8.10445 1.08325 7.8289 1.08325 7.54158V2.66659C1.08325 2.37927 1.19739 2.10372 1.40055 1.90055C1.60372 1.69739 1.87927 1.58325 2.16659 1.58325H7.04158C7.3289 1.58325 7.60445 1.69739 7.80762 1.90055C8.01078 2.10372 8.12492 2.37927 8.12492 2.66659V3.20825",
    stroke: "#163663",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4bacfcde3b61270f046886b3bf2c5d4e.svg";
export { ForwardRef as ReactComponent };